import { Component } from 'react';
import { connect } from 'react-redux';
import { getGeolocation } from '../actions';

class Geolocator extends Component {
  componentWillMount() {
    this.props.getGeolocation();
  }

  render() {
    return this.props.children;
  }
}

const mapStateToProps = null;
const mapDispatchToProps = { getGeolocation };
export default connect(mapStateToProps, mapDispatchToProps)(Geolocator);



// WEBPACK FOOTER //
// ./src/components/Geolocator.js